import React, { useEffect, useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput, { Country, parsePhoneNumber, type Value } from 'react-phone-number-input';
import { styled as materialStyled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import AlertIcon from '../../../assets/img/alert.svg';
import { theme } from '../../../theme/theme';

const StyledPhoneInput = materialStyled(PhoneInput)`
  ${({ error }) => {
    let borderColor: string;
    if (error) {
      borderColor = `1px solid ${theme.palette.shades.errorBrightMain} !important`;
    } else {
      borderColor = `1px solid ${theme.palette.shades.whiteBorder2} !important`;
    }

    return `
      border: ${borderColor};
      border-radius: 8px;
      padding: 8px;
      maxHeight: 40px;
       &:focus-within {
        border-color: ${theme.palette.shades.blueBorder} !important;
      }
      .PhoneInputInput {
        border: none;
        height: 100%;
        font-family: 'Inter';
        font-size: 15px;
        color: ${theme.palette.shades.placeHolder} !important;
        &:focus {
          outline: none;
        }
      }

      .PhoneInputCountrySelect {
        border: none;
        background-color: ${theme.palette.background.paper}; 
        font-size: medium;

        &:focus {
          background-color: ${theme.palette.background.paper}; 
        }

        &::-webkit-scrollbar {
          width: 6px;
        }
      }
    `;
  }}
`;

interface ICustomPhoneNumberInputProps {
  value?: string;
  handleChange: (_value: Value) => void;
  onBlur?: (_event: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  name?: string;
  disabled?: boolean;
  countryCode?: string;
  onErrorChange?: (_value: any) => void;
}

const CustomPhoneNumberInput = ({
  value,
  handleChange,
  onBlur,
  error,
  name,
  disabled,
  countryCode,
  onErrorChange,
}: ICustomPhoneNumberInputProps) => {
  const [localError, setLocalError] = useState<string | undefined>();

  const validateSingaporePhoneNumber = (phoneNumber: Value) => {
    if (!phoneNumber || typeof phoneNumber !== 'string') {
      return;
    }
    const country = parsePhoneNumber(phoneNumber);
    if (country?.country === 'SG' && phoneNumber) {
      const digits = phoneNumber.replace(/\D/g, '');
      if (digits.length > 10 || (digits[2] !== '8' && digits[2] !== '9')) {
        setLocalError('Invalid Mobile Number!');
      } else {
        setLocalError('');
      }
    } else {
      setLocalError('');
    }
  };

  const handleChangeWithValidation = (newValue: Value) => {
    handleChange(newValue);
    validateSingaporePhoneNumber(newValue);
  };

  useEffect(() => {
    if (onErrorChange) {
      onErrorChange(localError);
    }
  }, [localError, onErrorChange]);
  return (
    <Box width="100%">
      <StyledPhoneInput
        name={name}
        value={value}
        onChange={handleChangeWithValidation}
        defaultCountry={(countryCode as Country) || 'SG'}
        theme={theme}
        onBlur={onBlur}
        error={error}
        disabled={disabled}
        international
      />
      {error && (
        <Box display="flex" gap={0.8} mt={1}>
          <Box src={AlertIcon} component="img" />
          <FormHelperText sx={{ ...theme.typography.footnoteRegular2, color: '#DF0C3D' }}>{error}</FormHelperText>
        </Box>
      )}
    </Box>
  );
};

export default CustomPhoneNumberInput;
